// extracted by mini-css-extract-plugin
var _1 = "close-j0D_O";
var _2 = "details-UMw9X";
var _3 = "info-PU8CT";
var _4 = "item-lDRP4";
var _5 = "message-d3NWK";
var _6 = "name-oH5WB";
var _7 = "price-T3V2d";
var _8 = "qty-PE6lj";
var _9 = "title-GEnwX";
var _a = "view-DjFN7";
export { _1 as "close", _2 as "details", _3 as "info", _4 as "item", _5 as "message", _6 as "name", _7 as "price", _8 as "qty", _9 as "title", _a as "view" }
